(() => {
  const fit = (node, max) => {
    if (!node) return;
    const original = Number(node.dataset.fontSize || node.getAttribute('font-size'));
    node.dataset.fontSize = original;
    node.setAttribute('font-size', original);
    for (let size = original; size > 14 && node.getComputedTextLength() > max; size -= 1) node.setAttribute('font-size', size - 1);
  };
  const init = root => {
    root.querySelectorAll('[data-personal-poster]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const first = panel.querySelector('[data-personal-name="1"]');
      const second = panel.querySelector('[data-personal-name="2"]');
      const date = panel.querySelector('[data-personal-date]');
      const refresh = () => {
        const a = first.value.trim() || 'Anna';
        const b = second.value.trim() || 'Erik';
        const d = date.value ? date.value.split('-').reverse().join('.') : '14.06.2024';
        const text = { name1:a, name2:b, names:`${a} & ${b}`.toLocaleUpperCase('sv'), initials:`${[...a][0]} & ${[...b][0]}`.toLocaleUpperCase('sv'), date:d };
        panel.querySelectorAll('[data-personal-preview]').forEach(node => { node.textContent = text[node.dataset.personalPreview]; fit(node, 660); });
        first.setCustomValidity(first.value && !first.value.trim() ? 'Fyll i ett namn.' : '');
        second.setCustomValidity(second.value && !second.value.trim() ? 'Fyll i ett namn.' : '');
      };
      panel.addEventListener('input', refresh);
      document.fonts.ready.then(refresh);
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
